"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileshareTask = void 0;
const download_source_1 = require("./download-source");
class FileshareTask {
    constructor(fileshareOptions, zipPath = '') {
        this.fileshareOptions = fileshareOptions;
        this.zipPath = zipPath;
        this.downloadSource = download_source_1.DownloadSource.AzureFileshare;
    }
}
exports.FileshareTask = FileshareTask;
//# sourceMappingURL=fileshare-task.js.map